import { getSharedFilters, saveSharedFilters } from '../utils/filterStore';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { API_URL as CONFIG_API_URL } from '../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';
import { Target, Award, Crosshair, Link, Heart, Info, Calendar, Filter, ChevronDown, SlidersHorizontal, Check, Activity, ChevronRight, ChevronLeft } from 'lucide-react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import { Download, FileSpreadsheet } from 'lucide-react';

const ENGINE_ICONS = {
  /* INJECTED_MB_PC_LOGOS_v2 */
  '豆包': '/icons/doubao.png',
  '豆包(PC)': '/icons/doubao.png',
  '豆包(MB)': '/icons/doubao.png',
  '豆包（PC）': '/icons/doubao.png',
  '豆包（MB）': '/icons/doubao.png',
  'doubao': '/icons/doubao.png',
  '腾讯元宝(PC)': '/icons/yuanbao.png',
  '腾讯元宝(MB)': '/icons/yuanbao.png',
  '腾讯元宝（PC）': '/icons/yuanbao.png',
  '腾讯元宝（MB）': '/icons/yuanbao.png',
  '通义千问(PC)': '/icons/tongyi.png',
  '通义千问(MB)': '/icons/tongyi.png',
  '通义千问（PC）': '/icons/tongyi.png',
  '通义千问（MB）': '/icons/tongyi.png',
  '通义': '/icons/tongyi.png',
  '文心一言': '/icons/wenxin.png',
  '文心一言(PC)': '/icons/wenxin.png',
  '文心一言(MB)': '/icons/wenxin.png',
  'Deepseek': '/icons/deepseek.png',
  'DeepSeek': '/icons/deepseek.png',
  'deepseek': '/icons/deepseek.png',
  'Kimi': '/icons/kimi.png',
  'kimi': '/icons/kimi.png',
  '元宝': '/icons/yuanbao.png',
  '腾讯元宝': '/icons/yuanbao.png',
  '百度AI搜索': '/icons/baidu.png',
  '百度': '/icons/baidu.png',
  '小红书AI': '/icons/xiaohongshu.png',
  '抖音AI': '/icons/douyin.png',
  '小红书': '/icons/xiaohongshu.png',
  'xhs': '/icons/xiaohongshu.png',
  '微信搜一搜': '/icons/wechat.png',
  '微信': '/icons/wechat.png',
};

const engineLogoPlugin = {
  id: 'engineLogo',
  afterDraw: (chart) => {
    const xAxis = chart.scales.x;
    if (!xAxis) return;
    const ctx = chart.ctx;
    
    xAxis.ticks.forEach((tick, index) => {
      const rawLabel = typeof tick.label === 'string' ? tick.label : (Array.isArray(tick.label) ? tick.label[0] : xAxis.getLabelForValue(tick.value));
      if (!rawLabel) return;
      const label = rawLabel.toString();
      
      let matchedKey = Object.keys(ENGINE_ICONS).find(k => label.toLowerCase().includes(k.toLowerCase()));
      if (matchedKey) {
        const src = ENGINE_ICONS[matchedKey];
        if (!window.__iconCache) window.__iconCache = {};
        if (!window.__iconCache[src]) {
           const img = new Image();
           img.src = src;
           window.__iconCache[src] = img;
           img.onload = () => chart.update();
        }
        const img = window.__iconCache[src];
        if (img && img.complete && img.naturalHeight !== 0) {
           const xPos = xAxis.getPixelForTick(index);
           const yPos = xAxis.top + 6;
           ctx.drawImage(img, xPos - 8, yPos, 16, 16);
        }
      }
    });
  }
};


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  ChartTooltip,
  Legend,
  Filler
);

export default function EngineMonitor() {
  const { user } = useAuth();
  const [adminEmptyState, setAdminEmptyState] = useState(false);
  const navigate = useNavigate();
  const [showMediaCards, setShowMediaCards] = useState(false);
  const handleExportImage = async () => {
    const contentElement = document.getElementById('report-content');
    if (!contentElement) return;
    try {
      const canvas = await html2canvas(contentElement, { scale: 2, useCORS: true, backgroundColor: document.documentElement.classList.contains('dark') ? '#0f172a' : '#ffffff' });
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `引擎表现大盘_${new Date().toISOString().slice(0, 10)}.png`;
      link.click();
    } catch (error) {
      console.error('Failed to export image', error);
    }
  };

  const handleExportExcel = () => {
    if (!dashboardData) return;
    
    // 1. KPI Data
    const kpiSheetData = [
      ['指标名称', '当前值', '环比趋势', '变化值'],
      ['综合表现 SOV', dashboardData.kpiData.sov?.value || '-', dashboardData.kpiData.sov?.trend || '-', dashboardData.kpiData.sov?.trendValue || '-'],
      ['Top 1 占位率', dashboardData.kpiData.top1?.value || '-', dashboardData.kpiData.top1?.trend || '-', dashboardData.kpiData.top1?.trendValue || '-'],
      ['Top 3 占位率', dashboardData.kpiData.top3?.value || '-', dashboardData.kpiData.top3?.trend || '-', dashboardData.kpiData.top3?.trendValue || '-'],
      ['媒体信源收录', dashboardData.kpiData.mediaQuote?.value || '-', dashboardData.kpiData.mediaQuote?.trend || '-', dashboardData.kpiData.mediaQuote?.trendValue || '-'],
      ['正面情感倾向', dashboardData.kpiData.sentiment?.value || '-', dashboardData.kpiData.sentiment?.trend || '-', dashboardData.kpiData.sentiment?.trendValue || '-'],
    ];

    // 2. Engine Sentiment Data
    const engineSheetData = [
      ['引擎名称', '正面占比(%)', '中性占比(%)', '争议占比(%)', '负面占比(%)']
    ];
    (dashboardData.engineSentiment || []).forEach(engine => {
      engineSheetData.push([engine.name, engine.pos, engine.neu, engine.con, engine.neg]);
    });

    // 3. Media Quotes Data
    const mediaSheetData = [
      ['媒体来源', '引用次数']
    ];
    (dashboardData.mediaQuotes || []).forEach(media => {
      mediaSheetData.push([media.name, media.value]);
    });

    const wb = XLSX.utils.book_new();
    const wsKpi = XLSX.utils.aoa_to_sheet(kpiSheetData);
    const wsEngine = XLSX.utils.aoa_to_sheet(engineSheetData);
    const wsMedia = XLSX.utils.aoa_to_sheet(mediaSheetData);

    XLSX.utils.book_append_sheet(wb, wsKpi, "核心指标大盘");
    XLSX.utils.book_append_sheet(wb, wsEngine, "各引擎情感表现");
    XLSX.utils.book_append_sheet(wb, wsMedia, "信源媒体分布");

    XLSX.writeFile(wb, `引擎表现大盘数据_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const [openDropdown, setOpenDropdown] = useState(null);
  const filterBarRef = useRef(null);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (filterBarRef.current && !filterBarRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterBarRef]);
  
  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };
  
  // Advanced Multi-select State
  const [filters, setFilters] = useState(() => getSharedFilters({
    time: '最近 7 天',
    customDate: { start: '', end: '' },
    engines: ['全部 AI 引擎'],
    stages: ['全部阶段'],
    personas: ['全部人设'],
    packages: ['全部词包']
  }));
  
  useEffect(() => {
    saveSharedFilters(filters);
  }, [filters]);

  const toggleArrayFilter = (key, value, defaultAll) => {
    setFilters(prev => {
      let current = [...prev[key]];
      if (value === defaultAll) {
        return { ...prev, [key]: [defaultAll] };
      }
      
      current = current.filter(v => v !== defaultAll);
      
      if (current.includes(value)) {
        current = current.filter(v => v !== value);
        if (current.length === 0) current = [defaultAll];
      } else {
        current.push(value);
      }
      return { ...prev, [key]: current };
    });
  };

  const updateTimeFilter = (val) => {
    setFilters(prev => ({ ...prev, time: val }));
    if (val !== '自定义范围') setOpenDropdown(null);
  };

  const renderArrayLabel = (arr, defaultAll, prefix = '') => {
    if (arr.includes(defaultAll)) return prefix ? `${prefix}${defaultAll}` : defaultAll;
    if (arr.length === 1) return prefix ? `${prefix}${arr[0]}` : arr[0];
    return `已选 ${arr.length} 项`;
  };

  const [rankingView, setRankingView] = useState('platform'); // 'platform' or 'trend'
  
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [projectPersonas, setProjectPersonas] = useState(['全部人设']);
  const [projectPackages, setProjectPackages] = useState(['全部词包']);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setAdminEmptyState(false);
      try {
        const token = localStorage.getItem('token');
        const pid = localStorage.getItem('globalProject');
        const bid = localStorage.getItem('globalBrand');

        if (!bid || bid === 'all' || bid === 'undefined') {
            if (user && user.role === 'ADMIN') {
                setAdminEmptyState(true);
                setLoading(false);
                return;
            } else if (user) {
                // Try to find first brand and auto-switch
                try {
                    const bRes = await axios.get(`${API_URL}/brand-projects?system=geo`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    if (bRes.data && bRes.data.length > 0) {
                        const firstBrandId = bRes.data[0].id.toString();
                        localStorage.setItem('globalBrand', firstBrandId);
                        window.dispatchEvent(new Event('globalFilterChange'));
                        window.dispatchEvent(new Event('forceHeaderSync'));
                        return; // Let the event listener trigger a new fetch
                    }
                } catch(e) {
                    console.error('Failed to auto-switch brand', e);
                }
            }
        }
        
        
        let combinedPersonas = ['全部人设'];
        
        try {
          const sysRes = await axios.get(`${API_URL}/personas/system`);
          if (sysRes.data && Array.isArray(sysRes.data)) {
             combinedPersonas.push(...sysRes.data.map(p => p.name));
          }
        } catch(e) { console.error("Failed to fetch system personas", e); }

        try {
          if (bid && bid !== 'all' && bid !== 'undefined') {
            const brandRes = await axios.get(`${API_URL}/brand-projects/${bid}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (brandRes.data.success && brandRes.data.data.keywordPackages) {
              setProjectPackages(['全部词包', ...brandRes.data.data.keywordPackages.map(p => p.name)]);
            }
            if (brandRes.data.success && brandRes.data.data.personas) {
              combinedPersonas.push(...brandRes.data.data.personas.map(p => p.name));
            }
          } else {
            setProjectPackages(['全部词包']);
          }
        } catch(e) { console.error("Failed to fetch brand personas", e); }
        
        // Remove duplicates just in case
        setProjectPersonas([...new Set(combinedPersonas)]);

        let timeParams = {};
        if (filters.time === '最近 7 天') {
          const end = new Date();
          const start = new Date();
          start.setDate(end.getDate() - 7);
          timeParams.startDate = start.toISOString();
          timeParams.endDate = end.toISOString();
        } else if (filters.time === '最近 90 天') {
          const end = new Date();
          const start = new Date();
          start.setDate(end.getDate() - 90);
          timeParams.startDate = start.toISOString();
          timeParams.endDate = end.toISOString();
        } else if (filters.time === '全部时间') {
          // No start/end date restrictions
        } else if (filters.time === '最近 30 天') {
          const end = new Date();
          const start = new Date();
          start.setDate(end.getDate() - 30);
          timeParams.startDate = start.toISOString();
          timeParams.endDate = end.toISOString();
        } else if (filters.time === '自定义范围') {
          if (filters.customDate?.start) timeParams.startDate = new Date(filters.customDate.start).toISOString();
          if (filters.customDate?.end) {
             const endD = new Date(filters.customDate.end);
             endD.setHours(23, 59, 59, 999);
             timeParams.endDate = endD.toISOString();
          }
        }

        const res = await axios.get(`${API_URL}/dashboard/metrics`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            fetchMode: localStorage.getItem('globalFetchMode') || 'hybrid',
            engines: filters.engines.includes('全部 AI 引擎') ? 'all' : filters.engines.join(','),
            stages: filters.stages.includes('全部阶段') ? 'all' : filters.stages.join(','),
            personas: filters.personas.includes('全部人设') ? 'all' : filters.personas.join(','),
            packages: filters.packages && !filters.packages.includes('全部词包') ? filters.packages.join(',') : 'all',
            geoTaskId: pid || undefined,
            brandProjectId: bid || undefined,
            ...timeParams, timeRange: filters.time
          }
        });

        if (res.data.success) {
          // Adjust datasets colors
          const fetched = res.data.data;
          fetched.sovChartData.datasets[0].borderColor = '#2996cf'; // Using new theme
          fetched.sovChartData.datasets[0].backgroundColor = 'rgba(41, 150, 207, 0.1)';
          fetched.sovChartData.datasets[0].fill = true;
          fetched.sovChartData.datasets[0].tension = 0.4;
          
          fetched.rankingChartData.datasets[0].backgroundColor = '#2996cf';
          fetched.rankingChartData.datasets[0].borderRadius = 4;
          fetched.rankingChartData.datasets[1].backgroundColor = '#94a3b8';
          fetched.rankingChartData.datasets[1].borderRadius = 4;

          setDashboardData(fetched);
        }
      } catch (e) {
        console.error("Failed to load dashboard data", e);
      } finally {
        setLoading(false);
      }
      };
    fetchData();
    window.addEventListener('globalFilterChange', fetchData);
    return () => window.removeEventListener('globalFilterChange', fetchData);
  }, [filters]);

  const kpiData = dashboardData?.kpiData || {
    sov: { value: '-', trend: 'up', trendValue: '-' },
    top1: { value: '-', trend: 'up', trendValue: '-' },
    top3: { value: '-', trend: 'up', trendValue: '-' },
    mediaQuote: { value: '-', trend: 'down', trendValue: '-' },
    ownedMedia: { value: '-', trend: 'down', trendValue: '-' },
    sentiment: { value: '-', trend: 'up', trendValue: '-' },
  };

  const engineSentiment = dashboardData?.engineSentiment || [];
  const mediaQuotes = dashboardData?.mediaQuotes || [];
  const sovChartData = dashboardData?.sovChartData || { labels: [], datasets: [] };
  const rankingChartData = dashboardData?.rankingChartData || { labels: [], datasets: [] };

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { 
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function(context) {
            return context.dataset.label + ': ' + context.parsed.y + '%';
          }
        }
      }
    },
    scales: {
      y: { 
        min: 0,
        max: 100,
        grid: { color: 'rgba(148, 163, 184, 0.1)' },
        ticks: {
          callback: function(value) {
            return value + '%';
          }
        }
      },
      x: { grid: { display: false } }
    }
  };

  const rankingTrendData = dashboardData?.rankingTrendData || { labels: [], datasets: [] };

  // Set colors for rankingTrendData
  if (rankingTrendData.datasets && rankingTrendData.datasets.length >= 2) {
    rankingTrendData.datasets[0].borderColor = '#2996cf';
    rankingTrendData.datasets[0].backgroundColor = '#2996cf';
    rankingTrendData.datasets[0].tension = 0.4;
    rankingTrendData.datasets[0].borderWidth = 2;
    rankingTrendData.datasets[0].pointRadius = 3;
    rankingTrendData.datasets[0].pointBackgroundColor = '#fff';

    rankingTrendData.datasets[1].borderColor = '#94a3b8';
    rankingTrendData.datasets[1].backgroundColor = '#94a3b8';
    rankingTrendData.datasets[1].borderDash = [5, 5];
    rankingTrendData.datasets[1].tension = 0.4;
    rankingTrendData.datasets[1].borderWidth = 2;
    rankingTrendData.datasets[1].pointRadius = 3;
    rankingTrendData.datasets[1].pointBackgroundColor = '#fff';
  }

  const rankingLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, boxWidth: 8 } },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function(context) {
            return context.dataset.label + ': ' + context.parsed.y + '%';
          }
        }
      }
    },
    scales: {
      y: { 
        grid: { color: 'rgba(148, 163, 184, 0.1)' },
        ticks: { callback: function(value) { return value + '%'; } }
      },
      x: { grid: { display: false } }
    }
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, boxWidth: 8 } },
      tooltip: {
        callbacks: {
          label: function(context) {
            return context.dataset.label + ': ' + context.parsed.y + '%';
          }
        }
      }
    },
    scales: {
      y: { 
        grid: { color: 'rgba(148, 163, 184, 0.1)' },
        ticks: {
          callback: function(value) {
            return value + '%';
          }
        }
      },
      x: { grid: { display: false }, ticks: { padding: 22 } }
    }
  };

  return (
    <div className="max-w-full flex flex-col p-4 pb-12">
        {adminEmptyState && (
          <div className="flex flex-col items-center justify-center h-[60vh] text-gray-500 dark:text-gray-400 bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm mx-auto w-full max-w-4xl mt-10">
             <div className="mb-4">
                <svg className="w-20 h-20 text-gray-300 dark:text-gray-600 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
             </div>
             <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">全景大盘数据受限</h3>
             <p className="text-center max-w-md">大盘数据量庞大，不支持多品牌混合分析，请在顶部选择一个具体的品牌项目。</p>
          </div>
        )}
        {!adminEmptyState && (
          <>
      {/* Header & Title */}
      <div className="mb-4 flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">引擎表现大盘</h1>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">监控各 AI 引擎的品牌占位情况、情感健康度及媒体溯源</p>
        </div>
        <div className="flex items-center gap-3">
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#8B84AD] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportExcel}
          >
            <FileSpreadsheet className="w-4 h-4" />
            导出数据
          </button>
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#9EA9DF] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportImage}
          >
            <Download className="w-4 h-4" />
            导出图片
          </button>
        </div>
      </div>

      {/* Global Filter Bar */}
      <div ref={filterBarRef} className="relative z-40 bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-lg p-3 mb-6 flex flex-wrap items-center gap-3 shadow-sm">
        <div className="flex items-center text-sm font-medium text-gray-700 dark:text-slate-300 mr-2">
          <Filter size={16} className="mr-2 text-blue-500" /> 数据筛选
        </div>
        
        {/* Time Filter with Custom Date Inputs */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('time')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <Calendar size={14} />
            <span>{filters.time === '自定义范围' && filters.customDate.start ? `${filters.customDate.start} 至 ${filters.customDate.end}` : filters.time}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'time' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'time' && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              {['最近 7 天', '最近 30 天', '最近 90 天', '全部时间', '自定义范围'].map(opt => (
                <div key={opt} onClick={() => updateTimeFilter(opt)} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex justify-between items-center">
                  <span>{opt}</span>
                  {filters.time === opt && <Check size={14} className="text-blue-500" />}
                </div>
              ))}
              {filters.time === '自定义范围' && (
                <div className="px-4 py-3 bg-gray-50 dark:bg-slate-900/50 border-t border-gray-100 dark:border-slate-700 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">开始</span>
                    <input type="date" value={filters.customDate.start} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, start: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">结束</span>
                    <input type="date" value={filters.customDate.end} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, end: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <button onClick={() => setOpenDropdown(null)} className="w-full mt-2 bg-blue-500 text-white text-xs py-1.5 rounded hover:bg-blue-600 transition">确定</button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* AI Platform Filter (Multi-select) */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('engines')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.engines, '全部 AI 引擎')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'engines' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'engines' && (
            <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="py-1">
                <div onClick={() => toggleArrayFilter('engines', '全部 AI 引擎', '全部 AI 引擎')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2 font-medium">
                  <input type="checkbox" checked={filters.engines.includes('全部 AI 引擎')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span>全部 AI 引擎</span>
                </div>
                
                {['Kimi', 'DeepSeek', '豆包', '文心一言', '腾讯元宝', '通义千问', '小红书AI', '抖音AI', '百度AI搜索'].map(opt => {
                  const isDisabled = opt === '百度AI搜索';
                  if (opt === '豆包' || opt === '腾讯元宝' || opt === '通义千问') {
                     const baseName = opt;
                     const pcName = baseName + '(PC)';
                     const mbName = baseName + '(MB)';
                     const isMBDisabled = false; 
                     
                     return (
                        <div key={opt} className="px-4 py-2 flex flex-col gap-2 border-b border-gray-50 dark:border-slate-800/50 hover:bg-gray-50/50 dark:hover:bg-slate-700/50">
                           <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-300">
                              {ENGINE_ICONS[baseName] && <img src={ENGINE_ICONS[baseName]} alt={baseName} className="w-4 h-4 rounded-sm object-contain" />}
                              <span>{baseName}</span>
                           </div>
                           <div className="flex gap-2 pl-6">
                              <div onClick={(e) => { e.stopPropagation(); toggleArrayFilter('engines', pcName, '全部 AI 引擎') }} className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs cursor-pointer transition-colors border ${filters.engines.includes(pcName) ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                 <span>PC</span>
                              </div>
                              <div onClick={(e) => { 
                                  e.stopPropagation(); 
                                  if (!isMBDisabled) toggleArrayFilter('engines', mbName, '全部 AI 引擎'); 
                                }} 
                                className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors border ${isMBDisabled ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed dark:bg-slate-800/50 dark:border-slate-700 dark:text-slate-500' : (filters.engines.includes(mbName) ? 'bg-blue-50 border-blue-200 text-blue-700 cursor-pointer dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 cursor-pointer hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700')}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
                                 <span>MB</span>
                              </div>
                           </div>
                        </div>
                     );
                  }
                  return (
                  <div 
                    key={opt} 
                    onClick={(e) => { e.stopPropagation(); if (!isDisabled) toggleArrayFilter('engines', opt, '全部 AI 引擎') }} 
                    className={`px-4 py-2 text-sm flex items-center space-x-2 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-50 dark:bg-slate-900 text-gray-500' : 'text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer'}`}
                    title={isDisabled ? "暂未开放" : ""}
                  >
                    <input type="checkbox" checked={filters.engines.includes(opt)} disabled={isDisabled} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" />
                    {ENGINE_ICONS[opt] && <img src={ENGINE_ICONS[opt]} alt={opt} className="w-4 h-4 rounded-sm object-contain" />}
                    <span>{opt}{isDisabled ? ' (暂未开放)' : ''}</span>
                  </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Stage Filter (Multi-select) */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('stages')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.stages, '全部阶段', '意图: ')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'stages' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'stages' && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700 flex justify-between">
                <span>GEO 4A 漏斗 (可多选)</span>
              </div>
              <div onClick={() => toggleArrayFilter('stages', '全部阶段', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2 font-medium">
                <input type="checkbox" checked={filters.stages.includes('全部阶段')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <span>全部阶段</span>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Aware', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-start space-x-2">
                <input type="checkbox" checked={filters.stages.includes('Aware')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium">Aware (认知发现)</div>
                  <div className="text-[10px] text-gray-400">泛搜索，不知道具体品牌</div>
                </div>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Appeal', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-start space-x-2">
                 <input type="checkbox" checked={filters.stages.includes('Appeal')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium">Appeal (兴趣探索)</div>
                  <div className="text-[10px] text-gray-400">对品牌有印象，了解情况</div>
                </div>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Ask', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer bg-blue-50/30 flex items-start space-x-2">
                <input type="checkbox" checked={filters.stages.includes('Ask')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium text-blue-600 dark:text-blue-400">Ask (深度对比) <span className="ml-1 text-[10px] bg-red-100 text-red-600 px-1 rounded">防守核心</span></div>
                  <div className="text-[10px] text-gray-500">在不同竞品间做抉择判断</div>
                </div>
              </div>
              <div onClick={() => toggleArrayFilter('stages', 'Action', '全部阶段')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-start space-x-2">
                <input type="checkbox" checked={filters.stages.includes('Action')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" />
                <div>
                  <div className="font-medium">Action (决策转化)</div>
                  <div className="text-[10px] text-gray-400">询问价格/渠道，准备购买</div>
                </div>
              </div>
            </div>
          )}
        </div>

        
        {/* Packages Filter */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('packages')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.packages, '全部词包', '词包: ')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'packages' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'packages' && (
            <div className="absolute top-full left-0 mt-1 w-56 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden max-h-64 overflow-y-auto">
                <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700 flex justify-between">
                  <span>选择词包 (可多选)</span>
                </div>
                {projectPackages.map(opt => {
                  const isSelected = filters.packages && filters.packages.includes(opt);
                  return (
                    <div key={opt} onClick={() => toggleArrayFilter('packages', opt, '全部词包')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2">
                      <input type="checkbox" checked={isSelected} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                      <span className="truncate">{opt}</span>
                    </div>
                  );
                })}
            </div>
          )}
        </div>

        {/* Persona Filter (Multi-select) */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('personas')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.personas, '全部人设', '人设: ')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'personas' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'personas' && (
            <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="px-3 py-2 text-xs font-semibold text-gray-500 bg-gray-50 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700">可多选</div>
              {projectPersonas.map(opt => (
                <div key={opt} onClick={() => toggleArrayFilter('personas', opt, '全部人设')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2">
                  <input type="checkbox" checked={filters.personas.includes(opt)} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span>{opt}</span>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>

      <div id="report-content" className="bg-transparent space-y-6 pt-2 pb-4 px-1">
      {/* 5 KPI Cards */}
      <div className={`grid ${showMediaCards ? 'grid-cols-2 md:grid-cols-3 xl:grid-cols-6' : 'grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-[1fr_1fr_1fr_1fr_64px]'} gap-4 mb-6 relative z-10 transition-all duration-500 ease-in-out`}>
        {/* Card 1: 品牌提及率 */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-xl p-5 border border-gray-100 dark:border-slate-700/50 shadow-sm relative group hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start mb-2">
            <span className="text-sm font-medium text-gray-500 dark:text-slate-400">品牌提及率</span>
            <div className="p-1.5 bg-blue-50 dark:bg-blue-900/30 rounded-lg text-blue-600 dark:text-blue-400">
              <Target size={18} />
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{kpiData.sov.value}</h3>
            {kpiData.sov.trendValue && kpiData.sov.trendValue !== '-' && (
              <span className={`text-xs font-medium ${kpiData.sov.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`}>
                {kpiData.sov.trend === 'up' ? '↑' : '↓'} {kpiData.sov.trendValue}
              </span>
            )}
          </div>
          <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">含品牌次数 / 提问总数</p>
        </div>

        {/* Card 2: 首选占位率 */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-xl p-5 border border-gray-100 dark:border-slate-700/50 shadow-sm relative group hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start mb-2">
            <div className="flex items-center space-x-1">
              <span className="text-sm font-medium text-gray-500 dark:text-slate-400">首选占位率</span>
              <div className="relative flex items-center group/tooltip">
                <Info size={14} className="text-gray-400 cursor-help" />
                <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 hidden group-hover/tooltip:block w-56 p-2 bg-slate-800 dark:bg-slate-900 text-white text-xs rounded shadow-xl z-50 text-center border border-slate-700">
                  引擎在回答的 <span className="text-blue-400 font-bold">首个推荐位置 (Top 1)</span> 提及目标品牌的比例。
                  <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-800 dark:border-t-slate-900"></div>
                </div>
              </div>
            </div>
            <div className="p-1.5 bg-purple-50 dark:bg-purple-900/30 rounded-lg text-purple-600 dark:text-purple-400">
              <Award size={18} />
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{kpiData.top1.value}</h3>
            {kpiData.top1.trendValue && kpiData.top1.trendValue !== '-' && (
              <span className={`text-xs font-medium ${kpiData.top1.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`}>
                {kpiData.top1.trend === 'up' ? '↑' : '↓'} {kpiData.top1.trendValue}
              </span>
            )}
          </div>
          <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">Top 1 次数 / 提问总数</p>
        </div>

        {/* Card 3: 高位曝光率 */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-xl p-5 border border-gray-100 dark:border-slate-700/50 shadow-sm relative group hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start mb-2">
             <div className="flex items-center space-x-1">
              <span className="text-sm font-medium text-gray-500 dark:text-slate-400">高位曝光率</span>
              <div className="relative flex items-center group/tooltip">
                <Info size={14} className="text-gray-400 cursor-help" />
                <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 hidden group-hover/tooltip:block w-56 p-2 bg-slate-800 dark:bg-slate-900 text-white text-xs rounded shadow-xl z-50 text-center border border-slate-700">
                  引擎在回答的 <span className="text-blue-400 font-bold">前三推荐位置 (Top 3)</span> 提及目标品牌的比例。
                  <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-800 dark:border-t-slate-900"></div>
                </div>
              </div>
            </div>
            <div className="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg text-indigo-600 dark:text-indigo-400">
              <Crosshair size={18} />
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{kpiData.top3.value}</h3>
            {kpiData.top3.trendValue && kpiData.top3.trendValue !== '-' && (
              <span className={`text-xs font-medium ${kpiData.top3.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`}>
                {kpiData.top3.trend === 'up' ? '↑' : '↓'} {kpiData.top3.trendValue}
              </span>
            )}
          </div>
          <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">Top 3 次数 / 提问总数</p>
        </div>

        {/* Card 4: 情感健康度 */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-xl p-5 border border-gray-100 dark:border-slate-700/50 shadow-sm relative group hover:shadow-md transition-shadow">
          <div className="flex justify-between items-start mb-2">
            <span className="text-sm font-medium text-gray-500 dark:text-slate-400">情感健康度</span>
            <div className="p-1.5 bg-teal-50 dark:bg-teal-900/30 rounded-lg text-teal-600 dark:text-teal-400">
              <Heart size={18} />
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{kpiData.sentiment.value}</h3>
            {kpiData.sentiment.trendValue && kpiData.sentiment.trendValue !== '-' && (
              <span className={`text-xs font-medium ${kpiData.sentiment.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`}>
                {kpiData.sentiment.trend === 'up' ? '↑' : '↓'} {kpiData.sentiment.trendValue}
              </span>
            )}
          </div>
          <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">正面信息 / 总信息</p>
        </div>

        {/* 扩展入口卡片 (仅当未展开时显示) */}
        {!showMediaCards && (
          <div 
            onClick={() => setShowMediaCards(true)}
            className="bg-slate-50 dark:bg-slate-800/40 backdrop-blur-xl rounded-xl p-2 border border-dashed border-gray-300 dark:border-slate-600 flex flex-row xl:flex-col items-center justify-center cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/60 hover:border-blue-400 dark:hover:border-blue-500 transition-all group col-span-2 lg:col-span-4 xl:col-span-1 min-h-[80px]"
            title="展开媒体溯源数据"
          >
            <div className="p-1.5 bg-blue-50 dark:bg-blue-900/20 rounded-full text-blue-500 group-hover:scale-110 transition-transform xl:mb-3">
              <ChevronRight size={20} />
            </div>
            <span className="text-sm font-medium text-gray-500 dark:text-slate-400 group-hover:text-blue-500 dark:group-hover:text-blue-400 xl:hidden ml-2">媒体溯源</span>
            <span className="hidden xl:block text-xs font-medium text-gray-500 dark:text-slate-400 [writing-mode:vertical-rl] tracking-widest group-hover:text-blue-500 dark:group-hover:text-blue-400 opacity-80">媒体溯源</span>
          </div>
        )}

        {/* 展开后的媒体指标卡片 */}
        {showMediaCards && (
          <>
            {/* Card 5: 媒体引用率 */}
            <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-xl p-5 border border-gray-100 dark:border-slate-700/50 shadow-sm relative group hover:shadow-md transition-shadow animate-[fadeIn_0.3s_ease-out]">
              <div className="flex justify-between items-start mb-2">
                <span className="text-sm font-medium text-gray-500 dark:text-slate-400">媒体引用率</span>
                <div className="p-1.5 bg-orange-50 dark:bg-orange-900/30 rounded-lg text-orange-600 dark:text-orange-400">
                  <Link size={18} />
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{kpiData.mediaQuote.value}</h3>
                {kpiData.mediaQuote.trendValue && kpiData.mediaQuote.trendValue !== '-' && (
                  <span className={`text-xs font-medium ${kpiData.mediaQuote.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`}>
                    {kpiData.mediaQuote.trend === 'up' ? '↑' : '↓'} {kpiData.mediaQuote.trendValue}
                  </span>
                )}
              </div>
              <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">品牌引文 / 总引文数</p>
            </div>

            {/* Card 6: 自有命中率 */}
            <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl rounded-xl p-5 border border-gray-100 dark:border-slate-700/50 shadow-sm relative group hover:shadow-md transition-shadow animate-[fadeIn_0.4s_ease-out]">
              <div className="absolute top-2 right-2">
                <button 
                  onClick={(e) => { e.stopPropagation(); setShowMediaCards(false); }} 
                  className="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 bg-gray-50 hover:bg-gray-100 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-md transition-colors" 
                  title="收起媒体溯源"
                >
                  <ChevronLeft size={16} />
                </button>
              </div>
              <div className="flex justify-between items-start mb-2">
                <div className="flex items-center space-x-1">
                  <span className="text-sm font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap">自有命中率</span>
                  <div className="relative flex items-center group/tooltip">
                    <Info size={14} className="text-gray-400 cursor-help" />
                    <div className="absolute bottom-full mb-2 right-0 hidden group-hover/tooltip:block w-56 p-2 bg-slate-800 dark:bg-slate-900 text-white text-xs leading-relaxed rounded shadow-xl z-50 text-left border border-slate-700 break-words">
                      引用媒体源中，命中客户 <span className="text-blue-400 font-bold">自有媒体矩阵</span> 的百分比。
                      <div className="absolute top-full right-2 border-4 border-transparent border-t-slate-800 dark:border-t-slate-900"></div>
                    </div>
                  </div>
                </div>
                <div className="p-1.5 bg-rose-50 dark:bg-rose-900/30 rounded-lg text-rose-600 dark:text-rose-400 mr-6">
                  <Activity size={18} />
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{kpiData.ownedMedia.value}</h3>
                {kpiData.ownedMedia.trendValue && kpiData.ownedMedia.trendValue !== '-' && (
                  <span className={`text-xs font-medium ${kpiData.ownedMedia.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`}>
                    {kpiData.ownedMedia.trend === 'up' ? '↑' : '↓'} {kpiData.ownedMedia.trendValue}
                  </span>
                )}
              </div>
              <p className="text-xs text-gray-400 dark:text-slate-500 mt-2">自有引文 / 总引文数</p>
            </div>
          </>
        )}
      </div>

      {/* Main Charts Area */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 relative z-10">
        
        {/* Top Left: 品牌提及率趋势图 (承接 KPI 1) */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-base font-bold text-gray-900 dark:text-white">整体品牌提及率趋势</h2>
            <span className="text-xs text-gray-500">{filters.time === '自定义范围' && filters.customDate.start ? `${filters.customDate.start} 至 ${filters.customDate.end}` : filters.time}</span>
          </div>
          <div className="h-64">
            <Line data={sovChartData} options={lineOptions} />
          </div>
        </div>

        {/* Top Right: 各引擎占位表现 (承接 KPI 2 & 3) */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-base font-bold text-gray-900 dark:text-white">各平台占位漏斗 (Top 1 vs Top 3)</h2>
            <div className="flex bg-slate-100 dark:bg-slate-700/50 rounded-lg p-1">
              <button 
                onClick={() => setRankingView('platform')}
                className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${rankingView === 'platform' ? 'bg-white dark:bg-slate-600 text-gray-800 dark:text-white shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
              >
                平台分布
              </button>
              <button 
                onClick={() => setRankingView('trend')}
                className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${rankingView === 'trend' ? 'bg-white dark:bg-slate-600 text-gray-800 dark:text-white shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'}`}
              >
                历史趋势
              </button>
            </div>
          </div>
          <div className="h-64">
            {rankingView === 'platform' ? (
              <Bar data={rankingChartData} options={barOptions} plugins={[engineLogoPlugin]} />
            ) : (
              <Line data={rankingTrendData} options={rankingLineOptions} plugins={[engineLogoPlugin]} />
            )}
          </div>
        </div>

        {/* Bottom Left: 引擎情感健康度分布 (承接 KPI 5) */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-base font-bold text-gray-900 dark:text-white">引擎情感态度画像</h2>
            <div className="flex space-x-3 text-[11px] font-medium text-gray-600 dark:text-slate-300">
              <div className="flex items-center"><span className="w-2.5 h-2.5 rounded bg-[#397AAA] mr-1.5"></span>正向</div>
              <div className="flex items-center"><span className="w-2.5 h-2.5 rounded bg-slate-300 dark:bg-slate-600 mr-1.5"></span>中性</div>
              <div className="flex items-center"><span className="w-2.5 h-2.5 rounded bg-[#eabc6b] mr-1.5"></span>争议</div>
              <div className="flex items-center"><span className="w-2.5 h-2.5 rounded bg-[#e56d4e] mr-1.5"></span>负向</div>
            </div>
          </div>

          <div className="flex flex-col gap-3 mt-4 pb-4 pr-4 pl-1">
            {engineSentiment.map((engine, idx) => (
              <div key={idx} className="flex items-center my-1 h-6">
                <div className="w-28 text-xs font-semibold text-gray-700 dark:text-slate-300 shrink-0 flex items-center h-full">
                  {Object.keys(ENGINE_ICONS).find(k => engine.name.toLowerCase().includes(k.toLowerCase())) ? (
                    <img src={ENGINE_ICONS[Object.keys(ENGINE_ICONS).find(k => engine.name.toLowerCase().includes(k.toLowerCase()))]} className="w-4 h-4 mr-1.5 rounded-sm" alt="logo"/>
                  ) : null}
                  {engine.name}
                </div>
                <div className="flex-1 flex h-4 rounded-full overflow-hidden bg-gray-100 dark:bg-slate-700/50 shadow-inner">
                  {/* Positive - Tech Blue */}
                  <div 
                    className="bg-[#397AAA] hover:bg-[#397AAA]/80 transition-colors flex items-center justify-center text-[9px] leading-none pb-[1px] text-white/90 font-bold"
                    style={{ width: `${engine.pos}%` }}
                    title={`正面: ${engine.pos}%`}
                  >
                    {engine.pos > 10 ? `${engine.pos}%` : ''}
                  </div>
                  {/* Neutral - Slate */}
                  <div 
                    className="bg-slate-300 dark:bg-slate-600 hover:bg-slate-400 dark:hover:bg-slate-500 transition-colors flex items-center justify-center text-[9px] leading-none pb-[1px] text-slate-700 dark:text-slate-300 font-bold"
                    style={{ width: `${engine.neu}%` }}
                    title={`中性: ${engine.neu}%`}
                  >
                    {engine.neu > 10 ? `${engine.neu}%` : ''}
                  </div>
                  {/* Controversial - Amber */}
                  <div 
                    className="bg-[#eabc6b] hover:bg-[#eabc6b]/80 transition-colors flex items-center justify-center text-[9px] leading-none pb-[1px] text-white/90 font-bold"
                    style={{ width: `${engine.con}%` }}
                    title={`争议/多面: ${engine.con}%`}
                  >
                    {engine.con > 8 ? `${engine.con}%` : ''}
                  </div>
                  {/* Negative - Rose/Coral */}
                  <div 
                    className="bg-[#e56d4e] hover:bg-[#e56d4e]/80 transition-colors flex items-center justify-center text-[9px] leading-none pb-[1px] text-white/90 font-bold"
                    style={{ width: `${engine.neg}%` }}
                    title={`负面: ${engine.neg}%`}
                  >
                    {engine.neg > 8 ? `${engine.neg}%` : ''}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Right: 高频引用媒体溯源 (承接 KPI 4) */}
        <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-xl p-6 shadow-sm flex flex-col">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-base font-bold text-gray-900 dark:text-white">高频引用媒体溯源</h2>
            <button onClick={() => navigate("/mention-records")} className="text-xs text-blue-500 hover:text-blue-400 font-semibold bg-blue-50 dark:bg-blue-500/10 px-2 py-1 rounded cursor-pointer transition-colors hover:bg-blue-100 dark:hover:bg-blue-500/20">详情 &rarr;</button>
          </div>

          <div className="space-y-5 flex-1">
            {mediaQuotes.length === 0 ? (
               <div className="flex flex-col items-center justify-center h-48 text-slate-400 dark:text-slate-500">
                  <span className="text-sm">暂无媒体溯源数据</span>
                  <span className="text-xs mt-1 opacity-70">尚未开始统计</span>
               </div>
            ) : mediaQuotes.map((media, idx) => (
              <div key={idx} className="group cursor-pointer">
                <div className="flex justify-between items-end mb-1.5">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-semibold text-gray-800 dark:text-slate-200 group-hover:text-blue-500 transition-colors">{media.name}</span>
                    <span className="text-[10px] text-gray-400 dark:text-slate-500 font-mono">{media.domain}</span>
                  </div>
                  <div className="text-right flex items-baseline space-x-1">
                    <span className="text-sm font-bold text-gray-700 dark:text-slate-300">{media.count}</span>
                    <span className="text-[10px] text-gray-400">次</span>
                  </div>
                </div>
                <div className="w-full bg-slate-100 dark:bg-slate-700/50 h-1.5 rounded-full overflow-hidden">
                  <div 
                    className="bg-gradient-to-r from-blue-500 to-indigo-500 h-full rounded-full transition-all duration-500" 
                    style={{ width: `${media.percent}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
          
        </div>

      </div>
      </div>
          </>
        )}
    </div>
  );
}
